import { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import { toast } from 'sonner';
import { LogIn, Loader2 } from 'lucide-react';

export default function Login() {
    const { login } = useAuth();
    const nav = useNavigate();
    const loc = useLocation();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [busy, setBusy] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setBusy(true);
        try {
            await login(email, password);
            toast.success('Welcome back');
            const redirect = loc.state?.from || '/';
            nav(redirect);
        } catch (e) {
            toast.error(e?.response?.data?.detail || 'Login failed');
        } finally {
            setBusy(false);
        }
    };

    return (
        <div className="max-w-md mx-auto px-4 sm:px-6 lg:px-8 py-16">
            <div className="rrm-panel p-6">
                <h1 className="font-display text-3xl text-white">SIGN IN</h1>
                <p className="text-white/60 text-sm mt-1">Track orders and get member coupons.</p>
                <form onSubmit={submit} className="mt-6 space-y-3">
                    <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email" data-testid="login-email-input" className="w-full bg-white/5 border border-white/10 rounded-md px-3 py-2 text-sm" />
                    <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Password" data-testid="login-password-input" className="w-full bg-white/5 border border-white/10 rounded-md px-3 py-2 text-sm" />
                    <button disabled={busy} data-testid="login-submit-button" className="w-full px-4 py-2.5 rounded-md bg-[var(--rrm-red)] hover:bg-[var(--rrm-red2)] text-white font-semibold inline-flex items-center justify-center gap-2 disabled:opacity-50">
                        {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <LogIn className="w-4 h-4" />} Sign in
                    </button>
                </form>
                <div className="mt-4 text-sm text-white/60">
                    New to RRM? <Link to="/register" className="text-amber-300">Create an account</Link>
                </div>
                <div className="mt-2 text-xs text-white/40">
                    Admin? <Link to="/admin/login" className="text-amber-300">Sign in here</Link>
                </div>
            </div>
        </div>
    );
}
